import React, { Fragment } from "react";
import { CardFooter } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { useTranslation } from "react-i18next";
import { titleCase } from "../../../../utils/case";

const FooterCard = ({ onSubmit, onCancel, loading }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <CardFooter className="text-end">

        <Btn
          attrBtn={{
            color: "secondary",
            className: "m-r-15",
            type: "button",
            onClick: onCancel,
          }}
        >
          {titleCase(t("cancel"))}
        </Btn>
        <Btn
          attrBtn={{
            color: "primary",
            type: "button",
            disabled: loading,
            onClick: onSubmit,
          }}
        >
          {titleCase(t("submit"))}
        </Btn>
      </CardFooter>
    </Fragment>
  );
};

export default FooterCard;